/** Ordered, user-facing steps shown on the processing screen. */
export const PROCESSING_STEPS = [
	{ label: 'Reading your input', detail: 'Taking it all in' },
	{ label: 'Extracting events', detail: 'Figuring out names, days & times' },
	{ label: 'Pinning to the map', detail: 'Looking up places on Google' },
	{ label: 'Adding to your timeline', detail: 'Almost there…' },
] as const

/**
 * Elapsed-time thresholds (ms) at which the fake progress timer advances to the
 * next step. The backend doesn't report progress, so steps tick on a timer.
 */
const STEP_BOUNDARIES_MS = [3_000, 10_000, 45_000] as const

export const computeStepIndex = (elapsedMs: number): number => {
	let idx = 0
	for (const boundary of STEP_BOUNDARIES_MS) {
		if (elapsedMs >= boundary) idx += 1
	}
	return idx
}

/** How long an import can sit in Pending/Processing before we call it stuck. */
export const STUCK_THRESHOLD_MS = 10 * 60 * 1000
